/** Web stub — local notifications are native-only. */
export const EventType = {
  ACTION_PRESS: 2,
  PRESS: 1,
};

export const AndroidImportance = { HIGH: 4 };
export const RepeatFrequency = { DAILY: 1 };
export const TriggerType = { TIMESTAMP: 0 };

const notifee = {
  onBackgroundEvent: () => {},
  onForegroundEvent: () => () => {},
  getInitialNotification: async () => null,
  requestPermission: async () => ({ authorizationStatus: 1 }),
  createChannel: async () => {},
  setNotificationCategories: async () => {},
  cancelNotification: async () => {},
  createTriggerNotification: async () => {},
  displayNotification: async () => {},
};

export default notifee;
